const routes = {
  root: '/',
  landing: '/landing',
  preRegister: '/registration',
  register: '/registration/form',
  postRegister: '/registration/complete',
  resetPassword: '/registration/create-password',
  forgotPassword: '/registration/forgot-password',
  login: '/login',
  sso: '/sso',

  notifications: '/notifications',
  menu: '/menu',
  faq: '/faq',

  lobby: '/lobby',

  networking: '/networking-lounge',
  cloudflix: '/highlights',

  auditorium1: '/auditorium-hall-1',
  auditorium2: '/auditorium-hall-2',

  malexbooth: '/booths/7',
  smithbooth: '/booths/8',
  medicwavebooth: '/booths/15',
  primobooth: '/booths/11',
  philosmedbooth: '/booths/9',
  wellchembooth: '/booths/18',
  ciMedbooth: '/booths/12',
  menarinibooth: '/booths/13',
  iconMedicbooth: '/booths/14',
  arthrotechbooth: '/booths/17',

  exhibition1: '/exhibition-hall/1',
  exhibition2: '/exhibition-hall/2',
  exhibition3: '/exhibition-hall/3',

  lucky: '/lucky-draw',
  questions: '/live-questions',

  onDemand: '/on-demand',
  onDemandOral: '/on-demand/oral-presentations',
  onDemandPoster: '/on-demand/e-poster-presentations',
  onDemandBbs: '/on-demand/best-basic-science-award',
  onDemandRecorded1: '/on-demand/live-recorded-1',
  onDemandRecorded2: '/on-demand/live-recorded-2',
  onDemandRecorded3: '/on-demand/live-recorded-3',

  //virtual product theatre
  virtualProductLanding: '/virtual-product-theatre',
  smithNephew: '/smith-nephew',
  malexMedicalAsia1: '/malex-medical-asia/1',
  malexMedicalAsia2: '/malex-medical-asia/2',
} as const

type Route = typeof routes
export type RoutesType = Route[keyof Route]

export default routes
